import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  socialContainerStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "15px",
    marginBottom: "10px",
    padding: "1vh 0",
    borderRadius: 12,
    cursor: "pointer",
    border: "1px solid #D7D8D9",
    width:"80%"
  },
  socialTextStyle: {
    fontFamily: "Inter Tight !important",
    fontSize: "16px ",
    fontWeight: 600,
    color: "#000000",
  },
  socialImgStyle: {
    height: 30,
    marginRight: 90,
    marginLeft: 16,
  },
  facebook: {
    background: "#0078FF",
    color: "#FFFFFF",
  },
  apple: {
    background: "#090A0A",
    color: "#FFFFFF",
  },
}));

export default useStyles;
